import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../App';
import api from '../api';
import { ihtarYazisiOlustur, kapatmaKarariOlustur } from '../components/RuhsatBelgesiPDF';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';

const SABLONLAR = [
  { id: 'ihtar', icon: '⚠️', baslik: 'İhtar Yazısı', aciklama: 'Eksiklik/aykırılık tespitinde kullanılan resmi ihtar belgesi', renk: '#e65100' },
  { id: 'kapatma', icon: '🚫', baslik: 'Geçici Kapatma Kararı', aciklama: 'Ruhsat iptali veya geçici kapatma kararı belgesi', renk: '#b71c1c' },
  { id: 'yaptirim', icon: '💰', baslik: 'Yaptırım Bildirimi', aciklama: 'İdari para cezası bildirimi', renk: '#6a1b9a' },
  { id: 'uyari', icon: '📋', baslik: 'Uyarı Yazısı', aciklama: 'Genel uyarı/bilgilendirme yazısı', renk: '#1565c0' },
  { id: 'borc-sorgulama', icon: '🏛️', baslik: 'Kurum İçi Borç Sorgulama', aciklama: 'Ruhsat iptali için Mali Hizmetler Müdürlüğüne gönderilen form', renk: '#00695c' },
  { id: 'bayram-calisma', icon: '🇹🇷', baslik: 'Ulusal Bayram Tatili Çalışma Ruhsatı', aciklama: 'Ruhsat ve sicil bilgileriyle yıllık çalışma ruhsatı', renk: '#c62828' },
];

const bosForm = () => ({
  aciklama:'', muhur_no:'', karar_no:'', ceza_tutari:'',
  iptal_nedeni:'sahip_talebi', diger_neden:'',
  makbuz_tarihi:'', makbuz_seri:'', makbuz_no:'',
  gecerlilik_tarihi:`31.12.${new Date().getFullYear()}`,
});

export default function YaziSablonlari() {
  const { kullanici } = useContext(AuthContext);
  const [seciliSablon, setSeciliSablon] = useState(null);
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);
  const [seciliRuhsat, setSeciliRuhsat] = useState(null);
  const [form, setForm] = useState(bosForm);
  const [olusturuluyor, setOlusturuluyor] = useState(false);
  const [constBilgi, setConstBilgi] = useState({
    belediye:'ÜNYE BELEDİYESİ', belediye_adi:'Ünye Belediye Başkanlığı',
    baskan:'Hüseyin TAVLI', baskan_adi:'Hüseyin TAVLI', baskan_unvan:'BELEDİYE BAŞKANI',
  });

  useEffect(() => {
    api.get('/tanimlar/const').then(r => {
      const ayar = r.data || {};
      setConstBilgi(c => ({
        ...c, ...ayar,
        belediye_adi: ayar.belediye || c.belediye_adi,
        belediye_adresi: ayar.adres || '', belediye_tel: ayar.telefon || '',
        baskan_adi: ayar.baskan || c.baskan_adi,
      }));
    }).catch(() => {});
  }, []);

  const ruhsatAra = async () => {
    if (!ruhsatArama.trim()) return;
    try {
      const r = await api.get(`/ruhsat?q=${encodeURIComponent(ruhsatArama)}&limit=10`);
      setRuhsatSonuc(r.data.veriler || []);
    } catch { setRuhsatSonuc([]); }
  };

  const ruhsatSec = async (r) => {
    try {
      const det = await api.get(`/ruhsat/${r.id}`);
      setSeciliRuhsat(det.data);
    } catch { setSeciliRuhsat(r); }
    setRuhsatArama(`${r.rn} — ${r.unvan}`);
    setRuhsatSonuc([]);
  };

  const belgeCikti = async () => {
    if (!seciliRuhsat || !seciliSablon) return;
    setOlusturuluyor(true);
    try {
      if (seciliSablon === 'ihtar') {
        await ihtarYazisiOlustur(seciliRuhsat, constBilgi, form.aciklama || undefined);
      } else if (seciliSablon === 'kapatma') {
        await kapatmaKarariOlustur(seciliRuhsat, constBilgi, {
          muhur_no: form.muhur_no,
          karar_no: form.karar_no,
          ceza_tutari: form.ceza_tutari,
          kapatma_baslangic: new Date().toISOString(),
        }, form.aciklama);
      } else if (seciliSablon === 'yaptirim') {
        await yaptirimBildirimiOlustur(seciliRuhsat, constBilgi, form);
      } else if (seciliSablon === 'uyari') {
        await uyariYazisiOlustur(seciliRuhsat, constBilgi, form.aciklama);
      } else if (seciliSablon === 'borc-sorgulama') {
        await wordSablonuOlustur('borc-sorgulama', seciliRuhsat, constBilgi, form);
      } else if (seciliSablon === 'bayram-calisma') {
        await wordSablonuOlustur('bayram-calisma', seciliRuhsat, constBilgi, form);
      }
    } catch (err) {
      alert('PDF oluşturulurken hata: ' + err.message);
    } finally { setOlusturuluyor(false); }
  };

  return (
    <div>
      <div style={{marginBottom:'20px'}}>
        <h2 style={{color:'#1a237e',fontSize:'20px'}}>📄 Resmi Yazı & Karar Şablonları</h2>
        <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>3572 s.K., 2464 s.K., 5393 s.K. ve 6331 s.K. uyarınca resmi belge çıktısı</div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:'12px',marginBottom:'24px'}}>
        {SABLONLAR.map(s=>(
          <div key={s.id} onClick={()=>{setSeciliSablon(s.id);setForm(bosForm());}} className="card"
            style={{cursor:'pointer',border:`2px solid ${seciliSablon===s.id?s.renk:'#eee'}`,transition:'all 0.15s',background:seciliSablon===s.id?`${s.renk}10`:'#fff'}}>
            <div style={{fontSize:'28px',marginBottom:'8px'}}>{s.icon}</div>
            <div style={{fontWeight:'700',color:s.renk,fontSize:'14px',marginBottom:'4px'}}>{s.baslik}</div>
            <div style={{fontSize:'12px',color:'#888'}}>{s.aciklama}</div>
          </div>
        ))}
      </div>

      {seciliSablon && (
        <div className="card">
          <h3 style={{color:'#1a237e',fontSize:'16px',marginBottom:'16px'}}>
            {SABLONLAR.find(s=>s.id===seciliSablon)?.icon} {SABLONLAR.find(s=>s.id===seciliSablon)?.baslik}
          </h3>

          {/* İşyeri Arama */}
          <div className="form-group" style={{marginBottom:'16px'}}>
            <label>İşyeri / Ruhsat Seç *</label>
            <div style={{display:'flex',gap:'8px'}}>
              <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..."
                className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} style={{flex:1}} />
              <button className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
            </div>
            {ruhsatSonuc.length > 0 && (
              <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'160px',overflowY:'auto',background:'#fff',zIndex:10,position:'relative'}}>
                {ruhsatSonuc.map(r=>(
                  <div key={r.id} onClick={()=>ruhsatSec(r)}
                    style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                    onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                    <strong>{r.rn}</strong> — {r.unvan}
                    <div style={{fontSize:'11px',color:'#888'}}>{r.isyeri_adresi}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {seciliRuhsat && (
            <div style={{background:'#e8eaf6',padding:'12px',borderRadius:'8px',marginBottom:'16px',fontSize:'13px'}}>
              <strong style={{color:'#1a237e'}}>{seciliRuhsat.unvan}</strong>
              <div style={{color:'#555',marginTop:'4px'}}>{seciliRuhsat.rn} — {seciliRuhsat.isyeri_adresi}</div>
              <div style={{color:'#555'}}>{seciliRuhsat.ana_faaliyet_adi} — {seciliRuhsat.durum}</div>
            </div>
          )}

          {/* Şablona özgü alanlar */}
          {seciliSablon === 'kapatma' && (
            <div className="form-grid">
              <div className="form-group">
                <label>Karar No</label>
                <input value={form.karar_no} onChange={e=>setForm({...form,karar_no:e.target.value})} placeholder="2024/001" />
              </div>
              <div className="form-group">
                <label>Mühür No</label>
                <input value={form.muhur_no} onChange={e=>setForm({...form,muhur_no:e.target.value})} placeholder="M-2024-001" />
              </div>
              <div className="form-group">
                <label>İdari Para Cezası (TL)</label>
                <input type="number" value={form.ceza_tutari} onChange={e=>setForm({...form,ceza_tutari:e.target.value})} placeholder="0.00" />
              </div>
            </div>
          )}

          {seciliSablon === 'yaptirim' && (
            <div className="form-grid">
              <div className="form-group">
                <label>Karar No</label>
                <input value={form.karar_no} onChange={e=>setForm({...form,karar_no:e.target.value})} placeholder="2024/001" />
              </div>
              <div className="form-group">
                <label>Ceza Tutarı (TL) *</label>
                <input type="number" value={form.ceza_tutari} onChange={e=>setForm({...form,ceza_tutari:e.target.value})} placeholder="0.00" />
              </div>
            </div>
          )}

          {seciliSablon === 'borc-sorgulama' && (
            <div className="form-grid">
              <div className="form-group">
                <label>Ruhsat İptal Nedeni</label>
                <select value={form.iptal_nedeni} onChange={e=>setForm({...form,iptal_nedeni:e.target.value})}>
                  <option value="sahip_talebi">Ruhsat Sahibinin / Resmi Vekilinin Talebi</option>
                  <option value="vergi_sonlandirma">Vergi Kaydını Sonlandırma</option>
                  <option value="adres_degisikligi">Adres Değişikliği</option>
                  <option value="kolluk_tutanagi">Kolluk Kuvveti Tutanağı / İşyerinin Terk Edilmesi</option>
                  <option value="diger">Diğer</option>
                </select>
              </div>
              {form.iptal_nedeni === 'diger' && <div className="form-group"><label>Diğer Neden</label><input value={form.diger_neden} onChange={e=>setForm({...form,diger_neden:e.target.value})} /></div>}
            </div>
          )}

          {seciliSablon === 'bayram-calisma' && (
            <div className="form-grid">
              <div className="form-group"><label>Geçerlilik Tarihi</label><input value={form.gecerlilik_tarihi} onChange={e=>setForm({...form,gecerlilik_tarihi:e.target.value})} placeholder="31.12.2026" /></div>
              <div className="form-group"><label>Makbuz Tarihi</label><input type="date" value={form.makbuz_tarihi} onChange={e=>setForm({...form,makbuz_tarihi:e.target.value})} /></div>
              <div className="form-group"><label>Makbuz Seri No</label><input value={form.makbuz_seri} onChange={e=>setForm({...form,makbuz_seri:e.target.value})} /></div>
              <div className="form-group"><label>Makbuz No</label><input value={form.makbuz_no} onChange={e=>setForm({...form,makbuz_no:e.target.value})} /></div>
            </div>
          )}

          {!['borc-sorgulama','bayram-calisma'].includes(seciliSablon) && <div className="form-group">
            <label>{seciliSablon === 'ihtar' ? 'Tespit Edilen Aykırılıklar / İhtar Metni' : 'Gerekçe / Açıklama'}</label>
            <textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={4}
              placeholder={seciliSablon === 'ihtar'
                ? 'Tespit edilen eksiklik veya aykırılıkları yazın...'
                : 'Karar gerekçesini yazın...'} />
          </div>}

          <div style={{display:'flex',gap:'12px',justifyContent:'flex-end',marginTop:'16px'}}>
            <button className="btn btn-secondary" onClick={()=>{setSeciliSablon(null);setSeciliRuhsat(null);setRuhsatArama('');setRuhsatSonuc([]);}}>İptal</button>
            <button className="btn btn-primary" onClick={belgeCikti} disabled={!seciliRuhsat||olusturuluyor}>
              {olusturuluyor ? '⏳ Oluşturuluyor...' : `📄 ${['borc-sorgulama','bayram-calisma'].includes(seciliSablon) ? 'Word Belgesi İndir' : 'PDF Oluştur'}`}
            </button>
          </div>
        </div>
      )}

      {!seciliSablon && (
        <div className="card" style={{textAlign:'center',padding:'32px',color:'#aaa'}}>
          <div style={{fontSize:'36px',marginBottom:'8px'}}>☝️</div>
          <div>Yukarıdan bir şablon seçin</div>
        </div>
      )}
    </div>
  );
}

async function yaptirimBildirimiOlustur(ruhsat, const_, form) {
  const { createPDF } = await import('../pdfUtils');
  const doc = createPDF();
  const W = 210;
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  doc.setFont('Arial', 'bold'); doc.setFontSize(14); doc.setTextColor(33);
  doc.text((const_.belediye_adi || 'ÜNYE BELEDİYE BAŞKANLIĞI').toUpperCase(), W / 2, 20, { align: 'center' });
  doc.setFontSize(10); doc.setFont('Arial', 'normal');
  doc.text('Ruhsat ve Denetim Müdürlügü', W / 2, 26, { align: 'center' });

  doc.setDrawColor(106, 27, 154); doc.setLineWidth(1);
  doc.line(14, 30, W - 14, 30);

  doc.setFillColor(243, 229, 245);
  doc.rect(14, 33, W - 28, 12, 'F');
  doc.setFont('Arial', 'bold'); doc.setFontSize(13); doc.setTextColor(106, 27, 154);
  doc.text('İDARİ YAPTIRIM BİLDİRİMİ', W / 2, 41, { align: 'center' });

  doc.setFont('Arial', 'normal'); doc.setFontSize(10); doc.setTextColor(33);
  doc.text(`Tarih: ${fmt(new Date())}    Karar No: ${form.karar_no || '—'}`, W / 2, 52, { align: 'center' });

  doc.setFillColor(232, 234, 246); doc.rect(14, 56, W - 28, 28, 'F');
  let y = 62;
  const b = (l, v) => { doc.setFont('Arial','bold'); doc.text(l+':',18,y); doc.setFont('Arial','normal'); doc.text(v||'—',65,y); y+=6; };
  b('İşyeri Ünvani', ruhsat.unvan);
  b('Ruhsat No', ruhsat.rn);
  b('İşyeri Adresi', ruhsat.isyeri_adresi);
  b('Yetkili', ruhsat.adi ? `${ruhsat.adi} ${ruhsat.soyadi}` : ruhsat.unvan);

  y = 92;
  doc.setFont('Arial', 'bold'); doc.setFontSize(22); doc.setTextColor(106, 27, 154);
  doc.text(`${Number(form.ceza_tutari||0).toLocaleString('tr-TR')} TL`, W / 2, y + 10, { align: 'center' });
  doc.setFont('Arial', 'normal'); doc.setFontSize(10); doc.setTextColor(100);
  doc.text('İDARİ PARA CEZASI', W / 2, y + 18, { align: 'center' });
  y += 28;

  if (form.aciklama) {
    const lines = doc.splitTextToSize('Gerekce: ' + form.aciklama, W - 28);
    doc.setFont('Arial', 'normal'); doc.setFontSize(10); doc.setTextColor(33);
    doc.text(lines, 14, y); y += lines.length * 6 + 6;
  }

  doc.text('2464 sayili Belediye Gelirleri Kanunu ve ilgili mevzuat uyarinca tahakkuk ettirilen bu cezanin teblig tarihinden itibaren 30 gün icinde ödenmesi gerekmektedir.', 14, y, { maxWidth: W - 28 });

  doc.save(`yaptirim_${ruhsat.rn || ruhsat.id}.pdf`);
}

async function uyariYazisiOlustur(ruhsat, const_, aciklama) {
  const { createPDF } = await import('../pdfUtils');
  const doc = createPDF();
  const W = 210;
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  doc.setFont('Arial', 'bold'); doc.setFontSize(14); doc.setTextColor(33);
  doc.text((const_.belediye_adi || 'ÜNYE BELEDİYE BAŞKANLIĞI').toUpperCase(), W / 2, 20, { align: 'center' });
  doc.setFont('Arial', 'normal'); doc.setFontSize(10);
  doc.text('Ruhsat ve Denetim Müdürlügü', W / 2, 26, { align: 'center' });

  doc.setDrawColor(21, 101, 192); doc.setLineWidth(0.8);
  doc.line(14, 30, W - 14, 30);

  doc.setFont('Arial', 'bold'); doc.setFontSize(13); doc.setTextColor(21, 101, 192);
  doc.text('U Y A R I   Y A Z I S I', W / 2, 40, { align: 'center' });

  doc.setFont('Arial', 'normal'); doc.setFontSize(10); doc.setTextColor(33);
  doc.text(`Tarih: ${fmt(new Date())}`, W - 14, 50, { align: 'right' });

  doc.setFillColor(232, 234, 246); doc.rect(14, 54, W - 28, 22, 'F');
  let y = 60;
  const b2 = (l, v) => { doc.setFont('Arial','bold'); doc.text(l+':',18,y); doc.setFont('Arial','normal'); doc.text(v||'—',65,y); y+=6; };
  b2('İşyeri Ünvani', ruhsat.unvan);
  b2('Ruhsat No', ruhsat.rn);
  b2('İşyeri Adresi', ruhsat.isyeri_adresi);

  y = 84;
  const metin = aciklama || 'Yapilan denetimde isyerinizle ilgili tespit edilen hususta tarafiniz uyarilmaktadir. Gerekli önlemlerin alinmasi gerekmektedir.';
  const lines = doc.splitTextToSize(metin, W - 28);
  doc.setFont('Arial', 'normal'); doc.setTextColor(33);
  doc.text(lines, 14, y);

  doc.save(`uyari_${ruhsat.rn || ruhsat.id}.pdf`);
}

async function wordSablonuOlustur(tur, ruhsat, const_, form) {
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';
  const tarih = new Date().toLocaleDateString('tr-TR');
  const adSoyad = ruhsat.adi
    ? `${ruhsat.adi} ${ruhsat.soyadi || ''}`.trim()
    : (ruhsat.sicil_unvani || ruhsat.unvan || '');
  const faaliyet = ruhsat.ana_faaliyet_tam_adi || ruhsat.ana_faaliyet_adi || '';
  const ruhsatTarihi = fmt(ruhsat.onay_tarihi || ruhsat.basvuru_tarihi);
  const kullanimAlani = Number(ruhsat.kapali_alan || 0) + Number(ruhsat.acik_alan || 0);
  const neden = form.iptal_nedeni;

  const sablon = tur === 'borc-sorgulama'
    ? 'kurum-ici-borc-sorgulama.docx'
    : 'ulusal-bayram-calisma-ruhsati.docx';
  const response = await fetch(`/templates/${sablon}`);
  if (!response.ok) throw new Error('Word şablonu yüklenemedi.');

  const zip = new PizZip(await response.arrayBuffer());
  const belge = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
    delimiters: { start: '{{', end: '}}' },
    nullGetter: () => '',
  });
  belge.render({
    tarih,
    kimlik_no: ruhsat.tcno || ruhsat.vn || '',
    ad_soyad: adSoyad,
    isyeri_unvani: ruhsat.unvan || '',
    faaliyet,
    adres: ruhsat.isyeri_adresi || '',
    ruhsat_no: ruhsat.rn || '',
    verilis_tarihi: ruhsatTarihi,
    ruhsat_tarih_sayi: [ruhsatTarihi, ruhsat.rn].filter(Boolean).join('/'),
    kullanim_alani: kullanimAlani ? `${kullanimAlani.toLocaleString('tr-TR')} m²` : '',
    gecerlilik_tarihi: form.gecerlilik_tarihi || `31.12.${new Date().getFullYear()}`,
    baskan: const_.baskan || const_.baskan_adi || 'Hüseyin TAVLI',
    makbuz_tarihi: form.makbuz_tarihi ? fmt(`${form.makbuz_tarihi}T00:00:00`) : '……/……/20……',
    makbuz_seri: form.makbuz_seri || '……',
    makbuz_no: form.makbuz_no || '…………',
    neden_sahip: neden === 'sahip_talebi' ? '☒' : '☐',
    neden_vergi: neden === 'vergi_sonlandirma' ? '☒' : '☐',
    neden_adres: neden === 'adres_degisikligi' ? '☒' : '☐',
    neden_kolluk: neden === 'kolluk_tutanagi' ? '☒' : '☐',
    neden_diger: neden === 'diger' ? '☒' : '☐',
    diger_neden: neden === 'diger' ? (form.diger_neden || '') : '',
  });

  const blob = belge.getZip().generate({ type:'blob', mimeType:'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  const ad = tur === 'borc-sorgulama' ? 'kurum_ici_borc_sorgulama' : 'ulusal_bayram_calisma_ruhsati';
  saveAs(blob, `${ad}_${ruhsat.rn || ruhsat.id}.docx`);
}

async function borcSorgulamaOlustur(ruhsat, const_, form) {
  const { createPDF } = await import('../pdfUtils');
  const doc = createPDF();
  const W = 210;
  const bugun = new Date().toLocaleDateString('tr-TR');
  const adSoyad = ruhsat.adi ? `${ruhsat.adi} ${ruhsat.soyadi || ''}`.trim() : (ruhsat.sicil_unvani || ruhsat.unvan || '');
  const faaliyet = ruhsat.ana_faaliyet_tam_adi || ruhsat.ana_faaliyet_adi || '';
  const nedenler = [
    ['sahip_talebi', 'İşyeri Ruhsat Sahibinin / Resmi Vekilinin Talebi'],
    ['vergi_sonlandirma', 'Vergi Kaydını Sonlandırma'],
    ['adres_degisikligi', 'Adres Değişikliği'],
    ['kolluk_tutanagi', 'Kolluk Kuvveti Tutanağı (İşyerinin Terk Edilmesi)'],
    ['diger', `Diğer Nedenler${form.diger_neden ? `: ${form.diger_neden}` : ''}`],
  ];

  doc.setTextColor(0); doc.setFont('Arial', 'bold'); doc.setFontSize(11);
  doc.text('T.C.', W / 2, 15, { align:'center' });
  doc.text((const_.belediye || 'ÜNYE BELEDİYESİ').toUpperCase(), W / 2, 21, { align:'center' });
  doc.text('RUHSAT VE DENETİM MÜDÜRLÜĞÜ', W / 2, 27, { align:'center' });
  doc.setFontSize(12); doc.text('MALİ HİZMETLER MÜDÜRLÜĞÜNE', W / 2, 39, { align:'center' });

  doc.setFont('Arial', 'normal'); doc.setFontSize(9.5);
  const giris = `Ruhsat ve Denetim Müdürlüğümüze Ruhsat İptali için müracaat eden veya Müdürlüğümüzce tespit edilen / Vergi Kaydını Sonlandıran / Adres Değişikliği yapan aşağıda kimlik ve adres bilgileri yazılı olan şahsın/şirketin Kurumumuza olan borçlarının tahsil edilmesi hususu önemle arz olunur. ${bugun}`;
  doc.text(doc.splitTextToSize(giris, 180), 15, 50, { align:'justify', maxWidth:180 });

  doc.setFont('Arial', 'bold'); doc.setFontSize(10);
  doc.text('RUHSAT İPTALİ TALEBİNDE BULUNAN ŞAHSIN / FİRMANIN', 15, 73);
  let y = 78;
  const row = (label, value, height = 11) => {
    doc.rect(15, y, 180, height);
    doc.line(72, y, 72, y + height);
    doc.setFont('Arial','bold'); doc.setFontSize(8.5); doc.text(label, 18, y + 7);
    doc.setFont('Arial','normal');
    const lines = doc.splitTextToSize(String(value || '—'), 117);
    doc.text(lines, 75, y + 6.5);
    y += height;
  };
  row('T.C. Kimlik / Vergi No', ruhsat.tcno || ruhsat.vn);
  row('Adı ve Soyadı / Ünvanı', adSoyad);
  row('İşyeri Ünvanı', ruhsat.unvan);
  row('İşyeri Ana Faaliyet Konusu', faaliyet);
  row('İşyeri Adresi', ruhsat.isyeri_adresi, 16);

  doc.setFont('Arial','bold'); doc.text('İŞYERİ RUHSAT İPTAL NEDENİ', 15, y + 8); y += 12;
  nedenler.forEach(([key, label]) => {
    doc.rect(18, y, 4, 4);
    if (form.iptal_nedeni === key) { doc.setFont('Arial','bold'); doc.setFontSize(11); doc.text('X', 18.4, y + 3.7); }
    doc.setFont('Arial','normal'); doc.setFontSize(8.5); doc.text(label, 25, y + 3.5);
    y += 8;
  });
  doc.setFont('Arial','bold'); doc.setFontSize(9); doc.text('YAPILAN İŞ VE İŞLEMLER / SONUÇ', 15, y + 5);
  doc.rect(15, y + 8, 180, 36);
  doc.setFont('Arial','normal');
  doc.save(`kurum_ici_borc_sorgulama_${ruhsat.rn || ruhsat.id}.pdf`);
}

async function bayramCalismaRuhsatiOlustur(ruhsat, const_, form) {
  const { createPDF } = await import('../pdfUtils');
  const doc = createPDF();
  const W = 210;
  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const adSoyad = ruhsat.adi ? `${ruhsat.adi} ${ruhsat.soyadi || ''}`.trim() : (ruhsat.sicil_unvani || ruhsat.unvan || '');
  const faaliyet = ruhsat.ana_faaliyet_tam_adi || ruhsat.ana_faaliyet_adi || '';
  const alan = Number(ruhsat.kapali_alan || 0) + Number(ruhsat.acik_alan || 0);

  doc.setDrawColor(0); doc.setLineWidth(0.5); doc.rect(10, 10, 190, 277);
  doc.setFont('Arial','bold'); doc.setFontSize(12);
  doc.text('T.C.', W / 2, 20, {align:'center'});
  doc.text((const_.belediye || 'ÜNYE BELEDİYESİ').toUpperCase(), W / 2, 27, {align:'center'});
  doc.text('RUHSAT VE DENETİM MÜDÜRLÜĞÜ', W / 2, 34, {align:'center'});
  doc.setFontSize(15); doc.text('ULUSAL BAYRAM TATİLİ ÇALIŞMA RUHSATI', W / 2, 49, {align:'center'});

  let y = 60;
  const row = (label, value, height = 12) => {
    doc.rect(16, y, 178, height); doc.line(78, y, 78, y + height);
    doc.setFont('Arial','bold'); doc.setFontSize(8.5); doc.text(label, 19, y + 7.5);
    doc.setFont('Arial','normal');
    doc.text(doc.splitTextToSize(String(value || '—'), 110), 81, y + 6.5);
    y += height;
  };
  row('RUHSAT NO', ruhsat.rn);
  row('VERİLİŞ TARİHİ', fmt(ruhsat.onay_tarihi || ruhsat.basvuru_tarihi));
  row('T.C. NO / VERGİ NO', ruhsat.tcno || ruhsat.vn);
  row('ADI VE SOYADI / ŞİRKET ÜNVANI', adSoyad, 15);
  row('İŞYERİ ÜNVANI', ruhsat.unvan);
  row('FAALİYET KONUSU', faaliyet, 15);
  row('İŞYERİNİN ADRESİ', ruhsat.isyeri_adresi, 18);
  row('İŞYERİ AÇMA RUHSAT TARİH VE SAYISI', `${fmt(ruhsat.onay_tarihi || ruhsat.basvuru_tarihi)} / ${ruhsat.rn || '—'}`, 15);
  row('İŞYERİ KULLANIM ALANI', alan ? `${alan.toLocaleString('tr-TR')} m²` : '—');

  y += 10; doc.setFont('Arial','normal'); doc.setFontSize(10);
  const metin = `2464 Sayılı Belediye Gelirleri Kanunu’nun 58. maddesine göre ruhsat harcını her yıl OCAK ayında ödemek ve yenilemek şartı ile iş bu “Ulusal Bayram Tatili Çalışma Ruhsatı” ${form.gecerlilik_tarihi || `31.12.${new Date().getFullYear()}`} tarihine kadar düzenlenmiştir.`;
  doc.text(doc.splitTextToSize(metin, 170), 20, y, {align:'justify', maxWidth:170});

  const makbuzTarihi = form.makbuz_tarihi ? fmt(`${form.makbuz_tarihi}T00:00:00`) : '……/……/20……';
  doc.setFontSize(9); doc.text(`${makbuzTarihi} Tarih ve`, 22, 247);
  doc.text(`${form.makbuz_seri || '……'} Seri ${form.makbuz_no || '…………'} Sayılı`, 22, 253);
  doc.text('makbuzla harcı alınmıştır.', 22, 259);
  doc.setFont('Arial','bold'); doc.setFontSize(10);
  doc.text(const_.baskan || 'Hüseyin TAVLI', 158, 247, {align:'center'});
  doc.text('Belediye Başkanı', 158, 254, {align:'center'});
  doc.save(`ulusal_bayram_calisma_ruhsati_${ruhsat.rn || ruhsat.id}.pdf`);
}
